export default __webpack_public_path__ + "static/media/34.d277f52f.png";